<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_1"></a>The</p>
<p class="half-title2">Second World War</p>
<p class="half-title2">Illustrated</p>
<p class="half-title1"><em class="italic">The Third Year</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?7c7d6e22